import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_045.jpg';
page.images = [
  {
    imageId: 'page045_zoom0',
    rectangle: {
      x: 600,
      y: 1128,
      width: 1184,
      height: 728,
    },
    imageSrc: 'images/page045/045 2.jpg',
  },
  {
    imageId: 'page045_zoom1',
    rectangle: {
      x: 148,
      y: 512,
      width: 1642,
      height: 534,
    },
    imageSrc: 'images/page045/045 1.jpg',
  },
];
page.games = [
  {
    id: 'page045_game11',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 1114,
    },
    item: {
      id: 'page045_game11',
    },
    rectangle: {
      id: 'page045_rect1',
    },
  },
  {
    id: 'page045_game10',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 274,
    },
    item: {
      id: 'page045_game10',
    },
    rectangle: {
      id: 'page045_rect0',
    },
  },
];
page.rectangle = [
  {
    id: 'page045_rect0',

    tooltip: '',

    linked: ['page045_game10'],
    x: 122,
    y: 274,
    width: 1515,
    height: 200,
  },
  {
    id: 'page045_rect1',

    tooltip: '',

    linked: ['page045_game11'],
    x: 134,
    y: 1114,
    width: 450,
    height: 355,
  },
];
export default page;
